import { mapState } from "vuex";
import { ExternalResources } from "@constants";
import SearchModal from "@public-client/Components/SearchModal/SearchModal.vue";
import EmbeddedVideo from "@public-client/Components/Video.vue";
export default {
  components: {
    SearchModal,
    EmbeddedVideo
  },
  data() {
    return {
      ExternalResources: ExternalResources.IEPP
    };
  },
  computed: {
    ...mapState(["entities", "programs"]),
    stateSummary() {
      return this.$store.getters.stateSummary;
    },
    institutionCount() {
      return this.stateSummary.EntitiesCount;
    },
    programCount() {
      return this.stateSummary.HistoriesCount;
    }
  }
};